import { faXmark, faCheck, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { Item1 } from 'src/marketConnect/partials/content/activity/Item1';
import { getChannelDisplayName, getProductChannelLinkedStatus } from './linkingStatusUtils';

interface ProductLinkStatusTabProps {
  data?: any;
  channels: any[];
}

const ProductLinkStatusTab: React.FC<ProductLinkStatusTabProps> = ({ data, channels }) => {
  const [hovered, setHovered] = useState(false);

  const checkLinkedStatus = (type: string, platformId?: string | number) =>
    getProductChannelLinkedStatus(data, type, platformId);
  const anyLinked = channels?.some((item) => checkLinkedStatus(item.type, item.id) === 'linked');

  const popover = (
    <Popover id="popover-channels" className="shadow">
      <Popover.Body className="bg-white p-2 rounded">
        {channels?.map((item, idx) => {
          const isLinked = checkLinkedStatus(item.type, item.id);
          const color = isLinked === 'linked' ? '#198754' : '#dc3545';
          return (
            <div key={idx} className="d-flex align-items-center gap-2 mb-1 fw-medium">
              <FontAwesomeIcon icon={isLinked === 'linked' ? faCheck : faXmark} color={color} size="sm" />
              <span style={{ color }}>
                {getChannelDisplayName(item)}
              </span>
            </div>
          );
        })}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="right"
      overlay={popover}
      delay={{ show: 100, hide: 200 }}
      onToggle={(nextShow) => setHovered(nextShow)}
    >
      <Button
        className="d-flex p-0 overflow-hidden rounded border-0"
        style={{ background: 'transparent', }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {/* Left side */}
        <div
          className={`${anyLinked ? 'px-4' : 'px-3'} py-1 fw-medium text-white`}
          style={{
            backgroundColor: hovered
              ? anyLinked ? '#157347' : '#bb2d3b'
              : anyLinked ? '#198754' : '#dc3545',
            transition: 'background-color 0.2s',
          }}
        >
          {anyLinked ? 'Linked' : 'Unlinked'}
        </div>

        {/* Right caret side */}
        <div
          className="px-2 py-1 d-flex align-items-center border-start"
          style={{
            backgroundColor: anyLinked ? '#d1e7dd' : '#f8d7da',
            color: anyLinked ? '#198754' : '#dc3545',
          }}
        >
          <FontAwesomeIcon icon={faCaretRight} />
        </div>
      </Button>
    </OverlayTrigger>
  );
};

export default ProductLinkStatusTab;
